import { useEffect, useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';

import assetIdentificationBatchQuery from './assetIdentificationBatchQuery.graphql';

const POLLING_INTERVAL = 3000;

export const usePollAssetIdentificationBatch = () => {
  const [fetchBatch, { data, loading, error, called, stopPolling }] =
    useLazyQuery<
      AssetIdentificationBatchQuery,
      AssetIdentificationBatchQueryVariables
    >(assetIdentificationBatchQuery, {
      fetchPolicy: 'network-only',
      pollInterval: POLLING_INTERVAL,
      notifyOnNetworkStatusChange: true,
    });

  const startPolling = useCallback(
    (batchId: string) => {
      fetchBatch({ variables: { batchId } });
    },
    [fetchBatch],
  );

  const status = data?.assetIdentificationBatch?.status;

  const pollingFinished =
    called &&
    !loading &&
    (status === 'complete' || status === 'failed' || !!error);

  useEffect(() => {
    if (pollingFinished) {
      stopPolling();
    }
  }, [pollingFinished, stopPolling]);

  return {
    startPolling,
    data,
    loading,
    error,
    pollingFinished,
  };
};
